import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container } from 'react-bootstrap';
import PageHeader from '../../../shared/components/BreadCrumb';
import Forms from './components/Forms/index'

const CadastrosDisponibilidadeMain = () => {
    const { t } = useTranslation('common');
    return (
        <Container>
            <Col md={12}>
                <PageHeader
                    title="PROGRAMAÇÃO"
                    routeSegments={[
                        { name: 'Início', path: '/' },
                        { name: 'Programação', path: '/pages/programacao/disponibilidade' },
                        { name: 'Detalhes' },
                    ]}
                />
            </Col>
            <Forms />
        </Container>
    );
};

export default CadastrosDisponibilidadeMain;
